export const getters = {
	// geting state variables
	getScenario: (state) => state.haloScenario,
	getScenarioByName: (state) => (scenarioId) => state[scenarioId], //scenarioId is the name of a store scenario variable (string)
	getSelectedLoanId: (state) => state.selectedLoanId,
	getInvalidSections: (state) => (isTool) => isTool ? state.toolInvalidSections : state.haloInvalidSections,
	getCompareOptions: (state) => state.compareOptions,
	getSelectedRule: (state) => state.selectedRule,
	getCurrentOverride: (state) => state.currentOverride,
	getCurrentCompFactor: (state) => state.currentCompFactor,
	getPassingCompFactorLength: (state) => state.passingCompFactorLength,
	getHasRun: (state) => state.hasRun,
	getRulesAnimationState: (state) => state.rulesAnimationState,
	getSaved: (state) => state.saved,
	getSelectedSection: (state) => state.selectedSection,
	getDisplayValueChangeMessage: (state) => state.displayValueChangeMessage,
	getDisplayCompFactorMessage: (state) => state.displayCompFactorMessage,
	// gets the number of exceptions that have been made
	getUsers: (state) => state.users,
	getIsLegacyLoan: (state) => state.isLegacyLoan,

	// functions
	getSelectedProgram: (state) => (scenarioId) => {
		// scenarioId is the name of a store scenario variable(string)
		const programField = state[scenarioId].fields.find(f => f.name === 'Program');
		return programField.textValue;
	},
	getCompareOptionsTimes: (state) => { return state.compareOptions.map(o => o.created) },
	getTimeStringFromScenario: (state) => (scenarioName) => { return new Date(state[scenarioName].created).toLocaleString(); },
	getUsernames: (state) => {
		// map the users object to be an array of just usernames
		return state.users.map(u => u.username);
	},
	// user is allowed to make exceptions
	userIsUnderwriter: (state) => { return state.haloScenario.userPersonas.some(p => ['QDU Exceptions', 'QDU Manager', 'Administrator', 'Super Administrator'].indexOf(p) >= 0) },
	// user is allowed to make manager level exceptions
	userIsManager: (state) => { return state.haloScenario.userPersonas.some(p => ['QDU Manager', 'Administrator', 'Super Administrator'].indexOf(p) >= 0) },
	userIsAdmin: (state) => (scenarioId) => { return state[scenarioId].userPersonas.some(p => ['Administrator', 'Super Administrator'].indexOf(p) >= 0) },
	// the user is considered to be in the beta group if they have the 'QDU Beta' persona 
	// or if the user is an admin
	userIsInBetaGroup: (state, getters) => (scenarioId) => { 
		return (state[scenarioId].userPersonas.some(p => ['QDU Beta'].indexOf(p) >= 0) || getters.userIsAdmin(scenarioId));
	},
	getRulesToCrse: (state) => {
		const objectToSend = {
			rules: [],
			compFactors: []
		};
		for (let rule of state.haloScenario.rules) {
			if (rule.override && rule.override.sendToCrse) {
				objectToSend.rules.push(rule);
			}
		}
		objectToSend.compFactors = state.haloScenario.compensatingFactors.filter(cf => cf.valid);
		return objectToSend;
	}
};